import { IconButton, InputAdornment, Paper, TextField, Typography, withStyles } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { useEffect } from 'react'
import Email from '../assets/email.svg';
import BgRight from '../assets/bg_right.svg';
import Bg from '../assets/Bg.svg';
import Character from '../assets/character login.png';
import LogoLogin from '../assets/LogoLogin.png';
import Welcome from '../assets/welcome.png';
import Username from '../assets/ic_un.png';
import Password from '../assets/ic_pass.png';
import { useHistory } from 'react-router-dom';
import Constant from '../library/Constant';
import api from './api';

const InputBaru = withStyles({
    root: {
        '& .MuiInputBase-input': {
            fontFamily: 'Poppins',
            fontSize: '1.7vh',
            fontWeight: '500',
            boxSizing: 'border-box'
        },
        '& .MuiOutlinedInput-input': {
            padding: '2vh 1vh'
        },
        '& input:-internal-autofill-selected': {
            backgroundColor: 'transparent'
        },

        // MuiInputBase: {
        //     root: {
        //         fontFamily: 'Poppins',
        //     },
        //     input: {
        //         fontFamily: 'Poppins',
        //         fontSize: '12vh',
        //         boxSizing: 'border-box'
        //     }
        // }
    }
})(TextField);

const inputStyle = { WebkitBoxShadow: "0 0 0 1000px white inset" };


export default function LandingPage(props) {
    const history = useHistory()
    const [showPass, setShowPass] = React.useState(false)
    const [email, setEmail] = React.useState("")
    const [password, setPassword] = React.useState("")
    const [error, setError] = React.useState("")

    console.log(props);

    return (
        <div className="login-container" style={{ borderRadius: 20, marginTop: 10, height: '90vh' }}>
            <div style={{ padding: 20, width: '100%' }}>
                {/* <img src={LogoLogin} className="login-logo-carolus" /> */}
                <div style={{ display: 'flex' }}>
                    <img src={localStorage.getItem(Constant.LOGO_RS)} style={{ height: 80, width: 65, marginRight: 20 }} />
                    <div className='text-logo' style={{ alignSelf: 'center' }}>
                        <Typography style={{ fontSize: 46, fontWeight: 'bold', color: 'white', lineHeight: 1 }}>{localStorage.getItem(Constant.NAMA_RS)}</Typography>
                        <Typography style={{ fontSize: 20, fontWeight: '300', color: 'white' }}>{localStorage.getItem(Constant.DESCRIPTION_RS)}</Typography>
                    </div>
                </div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <span className="login-welcome-text">Welcome To Web Admin !</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography style={{ fontSize: 25, fontWeight: '300', color: 'white' }}>Please select a menu</Typography>
                    </div>
                </div>
                {/* <img src={Welcome} style={{ height: '6%', width: '75%', marginTop: '3%' }} /> */}
                <div className="login-logo-welcome bg-login">
                    <img src={Character} style={{ width: '35vh', zIndex: 100, contain: 'layout' }} />
                </div>
            </div>
        </div>
    )
}